import { useMemo } from 'react'
import { matchPath, useLocation, useNavigate } from 'react-router-dom'

export type UseTabsProps = {
  label: string
  path: string
}[]

const useTabs = (config: UseTabsProps, mainUrl: string) => {
  const location = useLocation()
  const navigate = useNavigate()

  const handleChange = (newIndex: number) => {
    navigate(`${mainUrl}${config[newIndex].path}${location.search}`)
  }

  const activeIndex = useMemo(() => {
    if (location.pathname.includes('/knowledge')) {
      return 3
    }

    return config.findIndex(item => {
      return matchPath({ path: `${mainUrl}${item.path}` }, location.pathname)
    })
  }, [config, location.pathname])

  return { activeIndex, handleChange }
}

export { useTabs }
